import { render, staticRenderFns } from "./WarningSnackbar.vue?vue&type=template&id=0fb43d27"
import script from "./WarningSnackbar.vue?vue&type=script&lang=js"
export * from "./WarningSnackbar.vue?vue&type=script&lang=js"
import style0 from "./WarningSnackbar.vue?vue&type=style&index=0&id=0fb43d27&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports